import React from 'react';

/**
 * ルーティング動作確認用ページ
 * ナビゲーションには表示しない。URLを直打ち(/routing-test)でアクセスして確認する。
 */
const RoutingTestPage: React.FC = () => {
  const currentPath = window.location.pathname;

  return (
    <div style={{ fontFamily: 'monospace', padding: '2rem', maxWidth: '600px', margin: '4rem auto' }}>
      <h1 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Routing Test Page</h1>
      <p style={{ marginBottom: '0.5rem' }}>
        このページが表示された場合、SPAルーティングは正常に動作しています。
      </p>
      <hr style={{ margin: '1rem 0' }} />
      <table style={{ borderCollapse: 'collapse', width: '100%' }}>
        <tbody>
          <tr>
            <td style={{ padding: '0.25rem 0.5rem', fontWeight: 'bold' }}>現在のパス:</td>
            <td style={{ padding: '0.25rem 0.5rem' }}>{currentPath}</td>
          </tr>
          <tr>
            <td style={{ padding: '0.25rem 0.5rem', fontWeight: 'bold' }}>URL:</td>
            <td style={{ padding: '0.25rem 0.5rem' }}>{window.location.href}</td>
          </tr>
          <tr>
            <td style={{ padding: '0.25rem 0.5rem', fontWeight: 'bold' }}>React Router:</td>
            <td style={{ padding: '0.25rem 0.5rem', color: 'green' }}>✔ 動作確認済み</td>
          </tr>
        </tbody>
      </table>
      <hr style={{ margin: '1rem 0' }} />
      <p style={{ fontSize: '0.875rem', color: '#666' }}>
        ※ このページはナビゲーションに表示されていません。
      </p>
    </div>
  );
};

export default RoutingTestPage;
